import { PackageSearch } from 'lucide-react';
import { landingRouteFor, useAuthStore } from '@/store/authStore';
import { LinkButton } from '@/components/ui/Button';

export function NotFoundPage() {
  const user = useAuthStore((state) => state.user);

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center px-6 text-center">
      <span className="inline-flex size-16 items-center justify-center rounded-2xl bg-brand-50 text-brand-600">
        <PackageSearch className="size-8" aria-hidden />
      </span>
      <p className="mt-6 text-sm font-bold text-brand-600">404</p>
      <h1 className="mt-1 text-2xl font-bold tracking-tight text-ink">Page not found</h1>
      <p className="mt-2 max-w-sm text-sm text-ink-muted">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <LinkButton to={user ? landingRouteFor(user) : '/login'} className="mt-6">
        {user ? 'Back to my workspace' : 'Go to sign in'}
      </LinkButton>
    </main>
  );
}
